import CustomSelect from "@Common/CustomSelect"
import Input from "@Common/input"
import { PhoneNumberField } from "@Common/PhoneNumberField"
import { isValidPhone } from "@utils"
import { useTranslation } from "react-i18next"
import PermissionsSummary from "../permissionsSummary"
import { useGetGetTeamMemberRoles } from "@services"
import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { IFormUserManagementCentre } from "../.."
import { LoadingWrapper } from "@components"

export default function FormInputsNewMember() {
	const {
		t,
		i18n: { language },
	} = useTranslation()
	/* ---------------------------------- API'S --------------------------------- */
	const { data, isLoading } = useGetGetTeamMemberRoles({})
	/* ---------------------------------- Hooks --------------------------------- */
	const { watch, control } = useFormContext<IFormUserManagementCentre>()
	const roleIdWatch = watch("roleId")
	const listOfPremissions = useMemo(() => {
		const dataList = data?.result.map((item) => {
			return {
				label: language === "en" ? item.roleName : item.roleNameAr,
				value: item.roleId.toString(),
			}
		})
		return dataList ?? []
	}, [data, language])

	const summaryOfPermissionsList = useMemo(() => {
		if (!roleIdWatch) return
		const permissionsList = data?.result.find(
			(item) => item?.roleId === Number(roleIdWatch)
		)?.permissions
		const res =
			permissionsList?.map((item) => {
				return {
					lable: language === "ar" ? item.titleAr : item.title,
					isActie: item.hasPermission,
				}
			}) ?? []
		return res ?? []
	}, [data, roleIdWatch, language])

	return (
		<LoadingWrapper loading={isLoading}>
			<div>
				<Input
					label={t("UserManagement.name")}
					placeholder={t("UserManagement.name")}
					name='fullName'
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
					}}
				/>
				<Input
					label={t("UserManagement.email")}
					placeholder={t("UserManagement.email")}
					name='email'
					type="email"
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
						pattern: {
							value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
							message: t("UserManagement.please_enter_valid_email") || "Please enter a valid email address",
						},
					}}
				/>
				<Controller
					name='phoneNumber'
					control={control}
					rules={{
						required: t("COMMON.REQUIRED"),
						validate: (value) =>
							isValidPhone(value) ||
							t("UserManagement.please_enter_the_mobile_number_correctly"),
					}}
					render={({
						field: { value, onChange, onBlur },
						fieldState: { error },
					}) => (
						<PhoneNumberField
							value={value}
							onChange={onChange}
							onBlur={onBlur}
							required
							label={t("UserManagement.phone_number")}
							placeholder={t("UserManagement.phone_number")}
							error={error?.message ? t(error.message) : undefined}
						/>
					)}
				/>
				<CustomSelect
					data={listOfPremissions}
					label={t("UserManagement.team_member_role")}
					name='roleId'
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
					}}
				/>

				{summaryOfPermissionsList && summaryOfPermissionsList?.length > 0 && (
					<PermissionsSummary
						summaryOfPermissionsList={summaryOfPermissionsList ?? []}
					/>
				)}
			</div>
		</LoadingWrapper>
	)
}
